export default {
  title: {
    base: 'Get in touch now',
    extra: 'There are no integration costs to setup and only takes 30 minutes to be onboarded!',
  },
  form: {
    inputs: {
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      contact_number: 'Contact number',
      clinic_name: 'Private clinic name',
      source: 'How did you hear about us?',
      reference: 'Referred by (if applicable):',
    },
    buttons: {
      submit: {
        default: 'Submit',
        done: 'Submitted',
      },
    },
  },
};
